
import { StyledLabel } from "./style";


export const Label = ({children, style}: {children: string, style?: React.CSSProperties}) => {
  return (
    <StyledLabel style={style} type="paragraphS" color="title" >{children.charAt(0).toUpperCase() + children.slice(1)}</StyledLabel>
  );
}